// stores/Auth.ts
import {defineStore} from 'pinia'
import ExpertService from "@/services/expert.service.ts";
import CommonService from "@/services/common.service.ts";

export const useCommonStore = defineStore('common', {
    state: () => ({}),

    actions: {
        async getExperts(params: Record<string, any>) {
            const res = await ExpertService.getExperts(params);
            return res.data.experts;
        },

        async addCreditCard(cardData: any) {
            return await CommonService.addCreditCard(cardData)
        },

        async cardPayment(paymentData: any) {
            return await CommonService.cardPayment(paymentData)
        },
    }
})
